import Cookies from 'js-cookie';

Date.prototype.Format = function(fmt)
{ //author: meizz
  var o = {
    "M+" : this.getMonth()+1,                 //月份
    "d+" : this.getDate(),                    //日
    "h+" : this.getHours(),                   //小时
    "m+" : this.getMinutes(),                 //分
    "s+" : this.getSeconds(),                 //秒
    "q+" : Math.floor((this.getMonth()+3)/3), //季度
    "S"  : this.getMilliseconds()             //毫秒
  };
  if(/(y+)/.test(fmt))
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)
    if(new RegExp("("+ k +")").test(fmt))
  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
  return fmt;
}

Date.prototype.Parse = function(str) {
  let group = str.match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/)
  this.setFullYear(group[1]);
  this.setMonth(group[2]-1);
  this.setDate(group[3]);
  this.setHours(0);
  this.setMinutes(0);
  this.setSeconds(0);
  this.setMilliseconds(0);
}

let storage = {
	token: Cookies.get("token"),
	// url: "http://127.0.0.1:7050/admin",
	url: "https://jianzao.genyun2019.cn/admin",
	isLogined: false,
	user: null,

    login(token) {
        this.token = token;
        Cookies.set("token", token);
    },
    logout() {
        this.token = null;
    },
    get(key) {
        return window.localStorage.getItem(key);
    },
    set(key, value) {
        window.localStorage.setItem(key, value)
    }
}

export default storage